import React, { useState } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import TextQuestion from "../../components/TextQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";
import { isMoneyValid, normaliseMoney } from "../../shared/utils/moneyUtils";

const BonusFromEmployer = ({ bonusFromEmployer, onStepComplete }) => {
  const [formState, setFormState] = useState({
    bonusFromEmployerAmount: bonusFromEmployer?.bonusFromEmployerAmount || "",
  });
  const [errors, setErrors] = useState({});
  const [errorMessages, setErrorMessages] = useState({});

  const handleInputChange = (field) => (value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleValidation = () => {
    let newErrors = {};
    let newErrorMessages = {};
    let formIsValid = true;

    if (!formState.bonusFromEmployerAmount) {
      newErrors.bonusFromEmployerAmount = true;
      newErrorMessages.bonusFromEmployerAmount = "Please fill this in";
      formIsValid = false;
    }

    if (formState.bonusFromEmployerAmount !== "" && !isMoneyValid(formState.bonusFromEmployerAmount)) {
      newErrors.bonusFromEmployerAmount = true;
      newErrorMessages.bonusFromEmployerAmount = "Please enter a valid amount";
      formIsValid = false;
    }

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);
    return formIsValid;
  };

  const handleMoneyValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    setErrors((prev) => {
      let newErrors = { ...prev };

      if (!isBlur) {
        newErrors[field] = false;
      } else {
        if (!formState[field]) {
          newErrors[field] = true;
        } else if (!isMoneyValid(formState[field])) {
          newErrors[field] = true;
        }
      }

      return newErrors;
    });
    setErrorMessages((prev) => {
      let newErrorMessages = { ...prev };

      if (isBlur) {
        if (!formState[field]) {
          newErrorMessages[field] = "Please fill this in";
        } else if (!isMoneyValid(formState[field])) {
          newErrorMessages[field] = "Please enter a valid amount";
        }
      }

      return newErrorMessages;
    });
  };

  const saveBonusFromEmployer = (event) => {
    event.preventDefault();

    if (handleValidation()) {
      onStepComplete({
        bonusFromEmployer: {
          bonusFromEmployerAmount: normaliseMoney(formState.bonusFromEmployerAmount),
        },
      });
    }
  };

  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="Tell us about the annual or one-off bonus from your employer" removeTopPadding>
        <p>
          We need to know how much you're contributing towards the purchase from the bonus you've received from your
          employer.
        </p>

        <TextQuestion
          question="How much are you using towards the purchase?"
          value={formState.bonusFromEmployerAmount}
          valueEntered={handleInputChange("bonusFromEmployerAmount")}
          validate={handleMoneyValidation("bonusFromEmployerAmount")}
          validationError={errors.bonusFromEmployerAmount ? errorMessages.bonusFromEmployerAmount : null}
        />

        <p>We'll ask you to provide a payslip for the month you received the bonus.</p>
        <Action onClick={saveBonusFromEmployer}>Continue</Action>
      </Card>
      <Image src={imageCatAndHousePlant} />
    </React.Fragment>
  );
};

export default BonusFromEmployer;
